import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import FAQs from "../FAQs";
import PrimaryButton from "components/buttons/primary-button";
import { ReactComponent as Arrow } from "images/svg/arrowRight.svg";
import PatternImg from "images/png/rated-playlist-background-pattern.png";
import PhoneImg from "images/png/rated-afrika-playlist.png";
import HowToGetFeatured from "../getFeatured";
import CTABg from "images/png/rated-afrika-playlist-submitTrack-bg.png";

const Default = () => {
  return (
    <div>
      <Header>
        <BgHeader src={PatternImg} alt="bg-pattern" />
        <HeaderPart>
          <Typography
            color={Colors.white100}
            size="4xl"
            weight="bold"
            m_size="xl"
            mb="3.2"
            m_mb="1.9"
          >
            Rated Afrika Playlist
          </Typography>

          <Typography
            color={Colors.white100}
            size="6rem"
            weight="bold"
            m_size="4xl"
            mb="1.6"
          >
            Get Heard. <LineBreak />
            Get Featured
          </Typography>
          <Typography size="2xl" color={Colors.grey500}>
            Submit your music today and join the{" "}
            <span style={{ color: Colors.grey100, fontWeight: 500 }}>
              Rated Afrika Playlist
            </span>
            , where the best African sounds connect with fans worldwide. Your
            next{" "}
            <span style={{ color: Colors.grey100, fontWeight: 500 }}>
              big break
            </span>{" "}
            starts here!
          </Typography>
          <CTA>
            <Typography size="xl" weight="medium" mb="1.6">
              Get the chance to be spotlighted on our Rated Afrika Playlist!
            </Typography>
            <PrimaryButton
              text="Submit Your Track"
              fitContent
              inset
              icon={<Arrow />}
              iconSize="2"
              iconPosition="right"
              sparkle
            />
          </CTA>
        </HeaderPart>
        <HeaderPart>
          <Phone src={PhoneImg} alt="phone" />
        </HeaderPart>
      </Header>
      <HowToGetFeatured />
      <FAQs />
    </div>
  );
};

export default Default;

const Header = styled.section`
  display: grid;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  grid-template-columns: 40% 50%;
  padding-bottom: 18rem;
  position: relative;

  @media only screen and (max-width: 769px) {
    grid-template-columns: 100%;
    padding-bottom: 1rem;
  }
`;

const BgHeader = styled.img`
  position: absolute;
  width: 100%;
  top: 18%;
  @media only screen and (max-width: 769px) {
    height: 100%;
    width: 350%;
    top: 0%;
    left: -10%;
  }
`;

const LineBreak = styled.br`
  display: block;
  @media only screen and (max-width: 769px) {
    display: none;
  }
`;

const HeaderPart = styled.div`
  position: relative;
`;
const Phone = styled.img`
  position: absolute;
  height: 75rem;
  top: -32rem;
  left: -23rem;

  @media only screen and (max-width: 769px) {
    position: relative;
    top: 0;
    left: -14rem;
    height: 70rem;
  }
`;
const CTA = styled.div`
  margin-top: 3.2rem;
  width: 85%;
  padding: 1.6rem 2.4rem;
  padding-right: 6.4rem;
  border-radius: 1.1rem;
  border: 1px solid #4e4e4e;
  background: linear-gradient(106deg, #131313 1.36%, #5b5b5b 100%),
    url(${CTABg});
  background-size: cover;
  background-position: center;
  background-blend-mode: overlay;

  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;
